import * as React from "react";
import {observer} from "mobx-react";
import {Icon} from "./Icon";

@observer
export class RecentFilesIcon extends Icon {

  render() {
    return <Icon {...this.props}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
            <path d="M24,4A20,20,0,1,0,44,24,20,20,0,0,0,24,4ZM34.51,32.41a1.82,1.82,0,0,1-2.56.28l-9.09-7.27A1.82,1.82,0,0,1,22.18,24V11.27a1.82,1.82,0,0,1,3.64,0V23.13l8.41,6.73A1.82,1.82,0,0,1,34.51,32.41Z"/>
        </svg>
      </Icon>;
  }
}
